//this is product list  page

import React, { useState, useEffect } from "react";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header/Header";
import { getProductsList } from "../../actions/ProductPageAction";
import { Link } from "react-router-dom";

import { useParams, useNavigate, useSearchParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { brandSession } from "../../actions/HomePageActions";
import { getCategoryList } from "../../actions/HomePageActions";
import { useLocation } from "react-router-dom";
import "./Products.css";

const Product = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const categoryList_ = useSelector((state) => state.homePageCategoryList);
  const { categoryList } = categoryList_;

  const brandSession_ = useSelector((state) => state.homePageBrand);
  const { brand } = brandSession_;
  console.log(brand);

  const products_ = useSelector((state) => state.productList);
  const { products, count, page, pages } = products_;
  const activeProducts =
  products?.filter((item) => item.active !== false) || [];

  console.log(products_, "products_");

  const [categoryFilter, setCategoryFilter] = useState("");
  const [brandFilter, setBrandFilter] = useState("");

  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const [urlParams, setUrlParams] = useState("?");

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category") || "";
  const keyword = searchParams.get("keyword") || "";
  const brandKey = searchParams.get("brand") || "";

  console.log(keyword);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pageNumber]);

  useEffect(() => {
    dispatch(getCategoryList());
    dispatch(brandSession());
  }, [dispatch]);

  useEffect(() => {
    let query = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (category) query += `&category=${category}`;
    if (keyword) query += `&keyword=${keyword}`;
    if (brandKey) query += `&brand=${brandKey}`;

    dispatch(getProductsList(query));
  }, [category, keyword, brandKey, pageNumber, pageSize, dispatch]);

  const clearFilter = () => {
    setCategoryFilter("");
    setBrandFilter("");
    setUrlParams("");
    dispatch(getProductsList(""));
    navigate("/products");
  };

  const handleFilterCategory = (val) => {
    setCategoryFilter(val);
    const params = new URLSearchParams(urlParams);
    params.set("category", val);
    const result = `?${params.toString()}`;
    setUrlParams(result);
    dispatch(getProductsList(result));
    navigate(result);
  };

  const handleFilterBrand = (val) => {
    setBrandFilter(val);
    const params = new URLSearchParams(urlParams);
    params.set("brand", val);
    const result = `?${params.toString()}`;
    setUrlParams(result);
    dispatch(getProductsList(result));
    navigate(result);
  };

  const handleNext = () => {
    console.log("first");
    console.log(pageNumber);
    console.log(pageSize);
    console.log(count);
    if (pageNumber * pageSize < count) {
      console.log("first 1");
      setPageNumber((prev) => prev + 1);
    }
  };

  useEffect(() => {
    setPageNumber(1);
  }, [category, keyword, brandKey]);

  return (
    <div className="template-index index-demo4">
      <div className="page-wrapper">
        <div className="classic-topHeader">
          <Header />
          <div id="" className="mb-0 ">
            <div className="container">
              <div className="row" style={{ marginTop: "10px" }}>
                {/* Main Content Area */}
                <div className="col-12 col-sm-12 col-md-9 col-lg-9 main-col">
                  {/* Banner */}
                  <div className="category-text-banner mb-4 mb-md-5">
                    <div className="banner-large rounded-0 bg-size">
                      <img
                        className="bg-img rounded-0 blur-up lazyload Top-Bg-Img"
                        src="/assets/images/category-img1.jpg"
                        alt="category"
                        style={{
                          width: "100%",
                          height: "310px",
                          objectFit: "cover",
                        }}
                      />
                      <div className="banner-content col-10 col-sm-8 col-md-6">
                        <h2 className="text-uppercase mb-2">
                          Shop The Latest Items
                        </h2>
                        <p>
                          Shop the latest Items with our weekly edit of what's
                          new in online at Adcaster collections.
                        </p>
                        <a href="#" className="btn btn-md">
                          Buy Now
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Toolbar */}
                  <div className="toolbar toolbar-wrapper shop-toolbar mb-4">
                    <div className="row align-items-center">
                      {/* Left side - View mode */}
                      <div className="col-4 col-sm-3 col-md-4 col-lg-4 text-left filters-toolbar-item d-flex order-1 order-sm-0">
                        <button
                          type="button"
                          className="btn btn-filter icon anm anm-sliders-hr d-inline-flex d-lg-none me-2"
                        >
                          <span className="d-none">Filter</span>
                        </button>
                        <div className="filters-item d-flex align-items-center">
                          <label className="mb-0 me-2 d-none d-lg-inline-block">
                            View as:
                          </label>
                          <div className="grid-options view-mode d-flex">
                            <a
                              className="icon-mode mode-list d-block active"
                              data-col="1"
                            ></a>
                          </div>
                        </div>
                      </div>

                      {/* Center - Pagination */}
                      <div className="col-12 col-sm-6 col-md-4 col-lg-4 text-center product-count order-0 order-md-1 mb-3 mb-sm-0">
                        <div className="pagination-container d-flex flex-column align-items-center">
                          <div
                            className="d-flex justify-content-center align-items-center mb-2 products-pagination-container"
                            style={{marginTop:"80px"}}
                          >
                            {/* Previous Button */}
                            <button
                              className="btn rounded-pill px-3 py-1 mx-2"
                              style={{
                                backgroundColor: "#000",
                                color: "#fff",
                                fontSize: "0.7rem",
                              }}
                              onClick={() =>
                                setPageNumber((prev) => Math.max(prev - 1, 1))
                              }
                              disabled={pageNumber === 1}
                            >
                              Previous
                            </button>

                            {/* Current Page Number */}
                            <span
                              className="mx-3 fw-bold"
                              style={{ fontSize: "0.85rem" }}
                            >
                              Page {products_?.page || 1} of{" "}
                              {products_?.pages || 1}
                            </span>

                            {/* Next Button */}
                            <button
                              className="btn rounded-pill px-3 py-1 mx-2"
                              style={{
                                backgroundColor: "#000",
                                color: "#fff",
                                fontSize: "0.7rem",
                              }}
                              onClick={() =>
                                setPageNumber((prev) =>
                                  Math.min(
                                    prev + 1,
                                    products_?.pages || prev + 1,
                                  ),
                                )
                              }
                              disabled={pageNumber === products_?.pages}
                            >
                              Next
                            </button>
                          </div>

                          <span className="toolbar-product-count">
                            Showing: {activeProducts?.length} products
                          </span>
                        </div>
                      </div>

                      {/* Right side - Show dropdown */}
                      <div className="col-8 col-sm-3 col-md-4 col-lg-4 text-right filters-toolbar-item d-flex justify-content-end order-2 order-sm-2">
                        <div className="filters-item d-flex align-items-center">
                          <label
                            htmlFor="ShowBy"
                            className="mb-0 me-2 text-nowrap d-none d-sm-inline-flex"
                          >
                            Show:
                          </label>
                          <select
                            name="ShowBy"
                            id="ShowBy"
                            className="filters-toolbar-show"
                            value={pageSize}
                            onChange={(e) => {
                              setPageSize(Number(e.target.value));
                              setPageNumber(1);
                            }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Products Grid */}
                  <div className="product-grid-container">
                    <div className="Sidebar-section-products">
                      {/* Sidebar */}
                      <div className="col-12 col-sm-12  sidebar-bg filterbar">
                        <div className="closeFilter d-block d-lg-none">
                          <i className="icon anm anm-times-r"></i>
                        </div>
                        <div className="sidebar-tags sidebar-sticky clearfix">
                          <div className="sidebar-widget filterBox filter-widget">
                            <div className="widget-title">
                              <h2>Filter By</h2>
                            </div>
                            <div className="widget-content filterby filterDD">
                              <a
                                href="#;"
                                className="btn btn-sm brd-link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  clearFilter();
                                }}
                              >
                                Clear All
                              </a>
                            </div>
                          </div>

                          <div className="sidebar-widget clearfix categories filterBox filter-widget">
                            <div className="widget-title">
                              <h2>Categories</h2>
                            </div>
                            <div className="widget-content filterDD">
                              <ul className="sidebar-categories scrollspy morelist clearfix">
                                {categoryList?.categories?.map(
                                  (category, index) => (
                                    <li
                                      key={index}
                                      className="lvl1 more-item"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleFilterCategory(category._id)
                                      }
                                    >
                                      <a
                                        href="#"
                                        className="site-nav"
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        {category.categoryName}
                                      </a>
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                          </div>

                          <div className="sidebar-widget filterBox filter-widget brand-filter">
                            <div className="widget-title">
                              <h2>Brands</h2>
                            </div>
                            <div className="widget-content filterDD">
                              <ul className="clearfix">
                                {brand?.brands?.map((brand, index) => (
                                  <li
                                    key={index}
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) =>
                                      handleFilterBrand(brand._id)
                                    }
                                  >
                                    <a
                                      href="#"
                                      className="site-nav"
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      {brand.brandName}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      {activeProducts?.length > 0 ? (
                        <>
                          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 g-3 g-md-4">
                            {activeProducts?.map((product, index) => (
                              <div key={index} className="col">
                                <div className="product-box h-100 d-flex flex-column">
                                  {/* Product Image */}
                                  <div className="product-image position-relative">
                                    <Link
                                      to={`/product/${product._id}`}
                                      className="product-img rounded-0 d-block"
                                    >
                                      <img
                                        className="rounded-0 blur-up lazyload w-100"
                                        src={
                                          product?.image1 !== ""
                                            ? product?.image1
                                            : "/assets/images/products/625x625.jpg"
                                        }
                                        alt={product.name || "Product"}
                                        title={product.name || "Product"}
                                        style={{
                                          width: "100%",
                                          height: "300px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Link>

                                    {/* Hover Buttons */}
                                    <div className="button-set style1">
                                      <a
                                        href="#quickshop-modal"
                                        className="btn-icon addtocart quick-shop-modal"
                                        data-bs-toggle="modal"
                                        data-bs-target="#quickshop_modal"
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        <span
                                          className="icon-wrap d-flex-justify-center h-100 w-100"
                                          data-bs-toggle="tooltip"
                                          data-bs-placement="left"
                                          title="Quick Shop"
                                        >
                                          <i className="icon anm anm-cart-l"></i>
                                          <span className="text">
                                            Quick Shop
                                          </span>
                                        </span>
                                      </a>

                                      <a
                                        href="#quickview-modal"
                                        className="btn-icon quickview quick-view-modal"
                                        data-bs-toggle="modal"
                                        data-bs-target="#quickview_modal"
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        <span
                                          className="icon-wrap d-flex-justify-center h-100 w-100"
                                          data-bs-toggle="tooltip"
                                          data-bs-placement="left"
                                          title="Quick View"
                                        >
                                          <i className="icon anm anm-search-plus-l"></i>
                                          <span className="text">
                                            Quick View
                                          </span>
                                        </span>
                                      </a>
                                    </div>
                                  </div>

                                  {/* Product Details */}
                                  <div className="product-details text-left pt-3 flex-grow-1 d-flex flex-column">
                                    <div className="product-name mb-2">
                                      <Link to={`/product/${product._id}`}>
                                        {product.name}
                                      </Link>
                                    </div>

                                    <div className="product-price mb-2">
                                      {product.offerPrice &&
                                      product.offerPrice < product.price ? (
                                        <>
                                          <span className="price old-price me-2 text-decoration-line-through">
                                            ₹{product.price}
                                          </span>
                                          <span className="price fw-bold">
                                            ₹{product.offerPrice}
                                          </span>
                                        </>
                                      ) : (
                                        <span className="price fw-bold">
                                          ₹{product.price}
                                        </span>
                                      )}
                                    </div>

                                    <p
                                      className="sort-desc mb-3 d-none d-lg-block"
                                      style={{
                                        fontSize: "0.875rem",
                                        lineHeight: "1.4",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        color: "#666",
                                      }}
                                    >
                                      {product.description}
                                    </p>

                                    <div className="button-action mt-auto">
                                      <div className="addtocart-btn">
                                        <Link
                                          to={`/product/${product._id}`}
                                          className="btn btn-md quick-shop quick-shop-modal w-100"
                                        >
                                          <span className="text">
                                            Quick Shop
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* Load More Button */}
                          <div className="infinitpaginOuter text-center mt-5 mb-5">
                            <div className="infiniteload">
                              <button
                                className="btn btn-xl loadMoreList"
                                onClick={handleNext}
                                disabled={pageNumber * pageSize >= count}
                                style={{
                                  padding: "12px 30px",
                                  fontSize: "1rem",
                                }}
                              >
                                Load More
                              </button>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ minHeight: "400px" }}
                        >
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Product;
